import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            今日吃瓜索引
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            按分类快速定位你感兴趣的黑料内容，一站式浏览全网热门吃瓜话题
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href="#"
              onClick={(e) => e.preventDefault()}
              className="group flex items-center gap-4 p-4 bg-background-50 border border-background-200 rounded-lg hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                <i className={`${item.icon} text-lg text-accent-600`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </div>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs text-foreground-400">{item.count}</span>
                  <span className="px-1.5 py-0.5 bg-accent-100 text-accent-700 text-xs rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors flex-shrink-0"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}